// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ef629b472dd8bc077e2faea5e9beb23d7c1972c8/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};